"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpClassTitle = exports.PlatesWrapper = exports.OtherDataWrapper = exports.ContentWrapper = exports.IconWrapper = exports.DescriptionWrapper = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentCardStyles2__Wrapper",
  componentId: "sc-1m3l1aw-0"
})(["display:flex;flex-direction:column;justify-content:flex-start;height:100%;cursor:pointer;border-radius:15px;background:#fff;color:", ";border-left:8px ", " solid;padding-left:3px;box-sizing:border-box;", ""], function (_ref) {
  var color = _ref.color;
  return color === 'white' || color === 'transparent' ? '#6197F5' : color;
}, function (_ref2) {
  var color = _ref2.color;
  return color;
}, function (_ref3) {
  var isOverAppointment = _ref3.isOverAppointment;
  return isOverAppointment && 'border: 0.2rem solid orange; box-sizing: border-box;';
});

exports.Wrapper = Wrapper;

var DescriptionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentCardStyles2__DescriptionWrapper",
  componentId: "sc-1m3l1aw-1"
})(["display:flex;flex-direction:row;align-items:center;justify-content:flex-start;font-size:10px;margin-top:3px;margin-left:2px;"]);

exports.DescriptionWrapper = DescriptionWrapper;

var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentCardStyles2__IconWrapper",
  componentId: "sc-1m3l1aw-2"
})(["display:flex;flex-direction:row;justify-content:flex-start;"]);

exports.IconWrapper = IconWrapper;

var ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentCardStyles2__ContentWrapper",
  componentId: "sc-1m3l1aw-3"
})(["display:flex;flex-direction:column;justify-content:flex-start;font-size:10px;"]);

exports.ContentWrapper = ContentWrapper;

var OtherDataWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentCardStyles2__OtherDataWrapper",
  componentId: "sc-1m3l1aw-4"
})(["display:flex;flex-direction:row;justify-content:", ";padding-bottom:0.4rem;font-size:10px;"], function (_ref4) {
  var expClass = _ref4.expClass;
  return expClass ? 'space-between' : 'flex-end';
});

exports.OtherDataWrapper = OtherDataWrapper;

var PlatesWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentCardStyles2__PlatesWrapper",
  componentId: "sc-1m3l1aw-5"
})(["display:flex;flex-direction:row;justify-content:center;align-items:flex-end;height:.8rem;width:auto;font-size:9px;border:1px solid;border-radius:.2rem;padding:0 4px;"]);

exports.PlatesWrapper = PlatesWrapper;

var ExpClassTitle = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentCardStyles2__ExpClassTitle",
  componentId: "sc-1m3l1aw-6"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;height:.8rem;width:auto;min-width:.8rem;font-size:8px;border:1px solid;border-radius:1.6rem;padding:0px;"]);

exports.ExpClassTitle = ExpClassTitle;